<template>
    <div style="position: relative;width: 100%;" v-if="show" :class="classObj" ref="triggerWrap">
        <div class="language">
            <div class="language_icon" v-if="showIcon">
                <img mode="aspectFill" :src="langImg" />
            </div>
            <slot name="langType"></slot>
        </div>
        <div v-if="isShowLangPopup" ref="portalRoot" class="lang_portal">
            <div class="mask" @click.stop="isShowLangPopup = false"></div>
            <div class="lang_content" :style="popupStyle">
                <div class="header">
                    <div>{{ $t("lang.ChangeLanguage") }}</div>
                    <div class="close" @click.stop="isShowLangPopup = false">
                        <i class="iconfont icon-s-cuowu-guanbi"></i>
                    </div>
                </div>
                <div class="langs">
                    <div v-for="(item, index) in langList" :key="index" class="outset_item"
                        :class="{ 'act': langType === item.type }" @click.stop="onSelLang(item.type)">
                        <div class="langs__item">
                            <div class="langs__item__img">
                                <van-image width="25px" height="25px" radius="50%" mode="aspectFill"
                                    :src="item.img"></van-image>
                            </div>
                            <div class="txt">{{ item.name }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'language',
    data() {
        return {
            isShowLangPopup: false,
            langList: [],
            popupStyle: {}
        }
    },
    computed: {
        langType() {
            return this.$store.getters.language
        },
        langImg() {
            let img = this.langObj[this.langType].img
            if (this.BelongNation === 'Nigeria') {
                img = require('@/assets/lang/Nigeria.jpeg')
            }
            return img
        },
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        showIcon: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        isShowLangPopup(val) {
            if (val) {
                this.$nextTick(() => {
                    const portal = this.$refs.portalRoot
                    if (portal && portal.parentNode !== document.body) {
                        document.body.appendChild(portal)
                    }
                })
            }
        }
    },
    created() { },
    beforeDestroy() {
        const portal = this.$refs.portalRoot
        if (portal && portal.parentNode === document.body) {
            document.body.removeChild(portal)
        }
    },
    methods: {
        onShowLangPopup() {
            this.langList = []
            let Arr = []
            const List = this.$store.getters.sysConfig?.countryList
            if (List) Arr = List.split(',')
            if (Arr && Arr.length) {
                Arr.forEach(x => {
                    const obj = this.langObj[x]
                    if (obj) this.langList.push(obj)
                })
            }
            if (!this.langList.length && this.langObj) {
                this.langList = Object.keys(this.langObj).map(key => this.langObj[key]).filter(Boolean)
            }
            if (!this.disabled) this.isShowLangPopup = true
            if (this.DisabledBelongCountry === 'disable') this.isShowLangPopup = false
            if (this.DisabledBelongCountry !== 'disable') this.isShowLangPopup = true
            if (!this.langList.length) this.isShowLangPopup = false
            this.$nextTick(() => {
                if (!this.isShowLangPopup) return
                const trigger = this.$refs.triggerWrap
                const portal = this.$refs.portalRoot
                if (!trigger) return
                const rect = trigger.getBoundingClientRect()
                const popupWidth = Math.min(264, window.innerWidth - 24)
                const popupMaxHeight = Math.min(384, window.innerHeight - 24)
                const popupEl = portal ? portal.querySelector('.lang_content') : null
                const popupHeight = popupEl ? Math.min(popupEl.offsetHeight || 0, popupMaxHeight) : Math.min(72 + this.langList.length * 82, popupMaxHeight)
                let left = rect.left
                let top = rect.bottom + 8
                if (left + popupWidth > window.innerWidth - 12) {
                    left = window.innerWidth - popupWidth - 12
                }
                if (left < 12) left = 12
                if (top + popupHeight > window.innerHeight - 12) {
                    top = Math.max(12, rect.top - popupHeight - 8)
                }
                this.popupStyle = {
                    position: 'fixed',
                    zIndex: 5002,
                    left: `${left}px`,
                    top: `${top}px`,
                    width: `${popupWidth}px`,
                    maxHeight: `${popupMaxHeight}px`
                }
            })
        },
        onSelLang(type) {
            this.$store.dispatch('system/setLanguage', type)
            this.$store.dispatch('system/setUserSetLanguage', type)
            this.$i18n.locale = type
            this.isShowLangPopup = false
            this.onPageRefresh()
            this.$emit('confirm')
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';
.language {
    // width: .64rem;
    // padding: 0 .1rem;
    height: .64rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    // justify-content: center;
    position: relative;
    z-index: 1001;

    .language_icon {
        width: .42rem;
        height: .42rem;
        border-radius: 50%;

        &>img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            overflow: hidden;
            vertical-align: top;
        }
    }
}

.mask {
    position: absolute;
    inset: 0;
    background: $bg-mask-color;
    z-index: 5000;
}

.lang_portal {
    position: fixed;
    inset: 0;
    z-index: 5000;
}

.lang_content {
    box-sizing: border-box;
    width: min(3.3rem, calc(100vw - .48rem));
    background: $bg-component-panel-color;
    border: .01rem solid rgba($border-component-active-blue-color, .35);
    border-radius: .22rem;
    position: fixed;
    top: 0;
    left: 0;
    transform: none;
    z-index: 5001;
    min-height: 1.5rem;
    max-height: min(4.8rem, calc(100vh - 1.2rem));
    overflow: hidden;
    box-shadow: 0 .18rem .5rem rgba($shadow-component-base-color, .45), 0 0 .2rem rgba($border-component-active-blue-color, .18);
    backdrop-filter: blur(8px);

    .header {
        text-align: left;
        color: $font-component-cool-color;
        font-size: .24rem;
        font-weight: 700;
        position: relative;
        padding: .18rem .2rem .14rem;
        border-bottom: 1px solid rgba($border-component-active-blue-color, .16);

        i {
            position: absolute;
            top: .14rem;
            right: .18rem;
            font-size: .28rem;
            color: rgba($font-component-cool-color, .92);
            cursor: pointer;
        }

        .close {
            position: absolute;
            top: 0;
            right: 0;
            width: .56rem;
            height: .56rem;
        }
    }

    .langs {
        padding: .1rem;
        overflow-y: auto;
        max-height: min(4rem, calc(100vh - 1.8rem));

        .outset_item {
            border-radius: .16rem;
            overflow: hidden;

            .langs__item {
                width: 100%;
                min-height: .72rem;
                background: $bg-component-blue-deep-gradient-color;
                display: flex;
                align-items: center;
                padding: 0 .18rem;
                cursor: pointer;
                box-sizing: border-box;
                border: 1px solid rgba($border-component-active-blue-color, .16);
                box-shadow: inset 0 1px 0 rgba($font-title-color, .04);
                transition: background .2s ease, border-color .2s ease, box-shadow .2s ease, transform .2s ease;

                &__img {
                    width: .42rem;
                    height: .42rem;
                    margin-right: .16rem;
                    flex-shrink: 0;
                }

                .txt {
                    font-style: normal;
                    font-weight: 600;
                    font-size: .2rem;
                    color: $font-component-cool-color;
                    line-height: 1.2;
                }
            }

            & + .outset_item {
                margin-top: .1rem;
            }

            &:hover {
                .langs__item {
                    border-color: rgba($border-component-active-blue-color, .28);
                    background: $bg-component-blue-deep-gradient-color;
                    box-shadow: 0 0 .14rem rgba($border-component-active-blue-color, .12), inset 0 1px 0 rgba($font-title-color, .06);
                }
            }

            &.act {
                .langs__item {
                    background: linear-gradient(90deg, $font-component-info-color 0%, $font-component-info-accent-color 100%);
                    border-color: rgba($border-component-active-blue-color, .58);
                    box-shadow: 0 0 .2rem rgba($border-component-active-blue-color, .22), inset 0 1px 0 rgba($font-title-color, .18);
                }

                .txt {
                    color: $font-color;
                }
            }
        }
    }
}
</style>
